module.exports = __webpack_public_path__ + "static/media/screenshot.4c3d8a61.svg";